import { render, staticRenderFns } from "./ExerciseIndicator.vue?vue&type=template&id=2b3547c1&"
import script from "./ExerciseIndicator.vue?vue&type=script&lang=js&"
export * from "./ExerciseIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports